import { INVOICE_STATUS } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const invoiceStatus = (method, url, payload) => ({
  url,
  method,
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload ? { payload } : {}),
  service: serviceName.MASTER_MS,
});

export const getInvoiceStatus = () => invoiceStatus(
  'get',
  `${INVOICE_STATUS}?cb=${Date.now()}`,
);

export const createInvoiceStatus = (invoiceStatusName) => invoiceStatus(
  'post',
  INVOICE_STATUS,
  { invoiceStatusName: invoiceStatusName },
);

export const updateInvoiceStatus = (
  invoiceStatusId,
  invoiceStatusName,
  isActive,
) => invoiceStatus(
  'put',
  `${INVOICE_STATUS}/${invoiceStatusId}`,
  {
    invoiceStatusName: invoiceStatusName,
    isActive: isActive,
  },
);
